module.exports = __webpack_public_path__ + "static/img/gaozhonglishi13.61d60001.jpg";